import React, { useEffect, useState } from 'react';
import './DefineNewPorjectPopup.scss';
import Rodal from '../../../../../components/Rodal/Rodal';
import { Col, ModalBody, ModalHeader, Row } from 'reactstrap';
import { DropdownList } from 'react-widgets/cjs';
import { ArrowDown } from '../../../../../components/arrow-down/arrow-down';
import { useStateSelector } from '../../../../../store/selectors';
import createNotification from '../../../../../utils/createNotification';
import ButtonLoader from '../../../../../components/Layout/Buttons/ButtonLoader';
import { DataForm } from '../../../../../models/DataRequestHub/DataForm';
import {
    ProjectTypeEnum,
    ProjectTypeEnumItem,
    ProjectTypeEnumList,
} from '../../../../../models/DataRequestHub/ProjectTypeEnum';
import Helpers from '../../../../../utils/helper';
import { DataTable } from '../../../../../models/DataRequestHub/DataTable';
import { DefineNewProjectTablesForm } from './DefineNewProjectTablesForm/DefineNewProjectTablesForm';

export interface PracticeOption {
    id: number;
    name: string;
    principalOwnerName: string;
    principalOwnereMail: string;
    practiceOwner: string;
}

export interface DefineNewProjectPopupProps {
    isVisible: boolean;
    setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
    onSubmit(): void;
}

export const DefineNewProjectPopup = (props: DefineNewProjectPopupProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const [dropDownOptions, setDropDownOptions] = useState([]);
    const [practiceNameOptions, setPracticeNameOptions] = useState([]);
    const [memberOptions, setMemberOptions] = useState([]);
    const [projectOptions, setProjectOptions] = useState([]);
    const [selectedPracticeOption, setSelectedPracticeOption] = useState(null);
    const [selectedMemberOption, setSelectedMemberOption] = useState(null);
    const [selectedProjectOption, setSelectedProjectOption] = useState(null);
    const [selectedDocumentTemplateId, setSelectedDocumentTemplateId] =
        useState<number>(null);
    const [
        selectedFinancialRequestsTemplateId,
        setSelectedFinancialRequestsTemplateId,
    ] = useState<number>(null);
    const [
        selectedQuestionnaireTemplateId,
        setSelectedQuestionnaireTemplateId,
    ] = useState<number>(null);
    const [selectedDataTableTemplateIds, setSelectedDataTableTemplateIds] =
        useState<number[]>(null);
    const [
        selectedDataTableViewTemplateIds,
        setSelectedDataTableViewTemplateIds,
    ] = useState<number[]>(null);
    const [questionnaireFormName, setQuestionnaireFormName] = useState('');
    const [questionnaireForms, setQuestionnaireForms] = useState<DataForm[]>(
        []
    );
    const [dataTables, setDataTables] = useState<DataTable[]>([]);
    const [tableFilters, setTalbeFilters] = useState<
        { field: string; value: string; operator: string }[]
    >([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDocumentDataFormVisible, setIsDocumentDataFormVisible] =
        useState(true);
    const [
        isFinancialRequestsDataFormVisible,
        setIsFinancialRequestsDataFormVisible,
    ] = useState(true);
    const [isQuestionnaireDataFormVisible, setIsQuestionnaireDataFormVisible] =
        useState(true);
    const [isDataTablesVisible, setIsDataTablesVisible] = useState(true);

    useEffect(() => {
        getPracticeNameOptions();
        getProjectOptions();
    }, []);

    const getProjectOptions = () => {
        const filteredProjectOptions = ProjectTypeEnumList.filter(
            (option) => option.id !== ProjectTypeEnum.Template
        );
        setProjectOptions(filteredProjectOptions);
    };

    const getPracticeNameOptions = () => {
        axios.get('/api/Practice').then((response) => {
            let list = response.data.data.filter(
                (x: PracticeOption) =>
                    x.id &&
                    isStringNotEmpty(x.name) &&
                    isStringNotEmpty(x.principalOwnerName) &&
                    isStringNotEmpty(x.principalOwnereMail)
            ) as PracticeOption[];
            list = list.map((obj: PracticeOption) => ({
                ...obj,
                practiceOwner: `${obj.principalOwnerName}, ${obj.principalOwnereMail}`,
            }));

            let practiceList = list.sort(
                (a: PracticeOption, b: PracticeOption) =>
                    Helpers.stringSortFunction(a.name, b.name)
            );
            let memberList = list.sort(
                (a: PracticeOption, b: PracticeOption) => {
                    const memberNameComparation = Helpers.stringSortFunction(
                        a.principalOwnerName,
                        b.principalOwnerName
                    );
                    if (memberNameComparation === 0) {
                        return Helpers.stringSortFunction(
                            a.principalOwnereMail,
                            b.principalOwnereMail
                        );
                    } else {
                        return memberNameComparation;
                    }
                }
            );
            list.unshift({
                id: 0,
                name: 'None',
                principalOwnerName: 'None',
                principalOwnereMail: 'None',
                practiceOwner: 'None',
            });
            setDropDownOptions(list);
            setPracticeNameOptions(practiceList);

            const uniqueMemberList = memberList.filter((item, index, array) => {
                return (
                    array.findIndex(
                        (i) => i.practiceOwner === item.practiceOwner
                    ) === index
                );
            });
            setMemberOptions(uniqueMemberList);
        });
    };

    const handlePracticeNameChange = (changedProperty: PracticeOption) => {
        let newFilters = [...tableFilters];
        newFilters = newFilters.filter((f) => f.field !== 'practice.id');
        if (changedProperty.id) {
            setSelectedPracticeOption(changedProperty);
            newFilters.push({
                field: 'practice.id',
                value: changedProperty.id.toString(),
                operator: 'eq',
            });
        }
        let memberList = changedProperty.id
            ? dropDownOptions.filter(
                  (x) =>
                      x.principalOwnereMail ===
                          changedProperty.principalOwnereMail || x.id === 0
              )
            : dropDownOptions;
        memberList = memberList.sort((a: PracticeOption, b: PracticeOption) => {
            if (a.id === 0) {
                return -1;
            }
            if (b.id === 0) {
                return 1;
            }
            const memberNameComparation = Helpers.stringSortFunction(
                a.principalOwnerName,
                b.principalOwnerName
            );
            if (memberNameComparation === 0) {
                return Helpers.stringSortFunction(
                    a.principalOwnereMail,
                    b.principalOwnereMail
                );
            } else {
                return memberNameComparation;
            }
        });
        const uniqueMemberList = memberList.filter((item, index, array) => {
            return (
                array.findIndex(
                    (i) => i.practiceOwner === item.practiceOwner
                ) === index
            );
        });
        setMemberOptions(uniqueMemberList);
        setTalbeFilters(newFilters);
    };

    const handleProjectOptionChange = (
        changedProperty: ProjectTypeEnumItem
    ) => {
        setSelectedProjectOption(changedProperty);
    };
    const getTablesByQuestionnaireId = (questionnaireId: number) => {
        const selectedQuestionnaire = questionnaireForms.find(
            (x) => x.id === questionnaireId
        );

        if (!selectedQuestionnaire) {
            return [];
        }
        const tableViewIds = selectedQuestionnaire.questions
            .filter((x) => x.tableViewId)
            .map((x) => x.tableViewId);
        const tableIds = dataTables
            .filter((table) =>
                table.views.some((view) => tableViewIds.includes(view.id))
            )
            .map((table) => table.id);
        const uniqueTableIds = Array.from(new Set(tableIds));
        return uniqueTableIds;
    };

    const getTableViewsByQuestionnaireId = (questionnaireId: number) => {
        const selectedQuestionnaire = questionnaireForms.find(
            (x) => x.id === questionnaireId
        );

        if (!selectedQuestionnaire) {
            return [];
        }
        const tableViewIds = selectedQuestionnaire.questions
            .filter((x) => x.tableViewId)
            .map((x) => x.tableViewId);
        const uniqueTableViewIds = Array.from(new Set(tableViewIds));
        return uniqueTableViewIds;
    };

    const isStringNotEmpty = (str: string) => {
        return str !== null && str.match(/^ *$/) === null;
    };

    const handleMemberChange = (changedProperty: PracticeOption) => {
        let newFilters = [...tableFilters];
        newFilters = newFilters.filter((f) => f.field !== 'practice.id');
        if (changedProperty.id) {
            setSelectedMemberOption(changedProperty);
            newFilters.push({
                field: 'practice.id',
                value: changedProperty.id.toString(),
                operator: 'eq',
            });
        }
        let practiceList = changedProperty.id
            ? dropDownOptions.filter(
                  (x) =>
                      x.principalOwnereMail ===
                          changedProperty.principalOwnereMail || x.id === 0
              )
            : dropDownOptions;
        practiceList = practiceList.sort(
            (a: PracticeOption, b: PracticeOption) => {
                if (a.id === 0) {
                    return -1;
                }
                if (b.id === 0) {
                    return 1;
                }
                return Helpers.stringSortFunction(a.name, b.name);
            }
        );
        setPracticeNameOptions(practiceList);

        setTalbeFilters(newFilters);
    };

    const defineNewProject = () => {
        setIsLoading(true);
        const obj = {
            name: ProjectTypeEnumList.find(
                (f) => f.id === selectedProjectOption.id
            )?.name,
            projectType: selectedProjectOption.id,
            practiceId: selectedPracticeOption.id,
            memberEmail: selectedMemberOption.principalOwnereMail,
            documentTemplateId: isDocumentDataFormVisible
                ? selectedDocumentTemplateId
                : 0,
            financialRequestsTemplateId: isFinancialRequestsDataFormVisible
                ? selectedFinancialRequestsTemplateId
                : 0,
            questionnaireTemplateId: isQuestionnaireDataFormVisible
                ? selectedQuestionnaireTemplateId
                : 0,
            questionnaireFormName: isQuestionnaireDataFormVisible
                ? questionnaireFormName
                : '',
            dataTableTemplateIds: isDataTablesVisible
                ? selectedDataTableTemplateIds
                : getTablesByQuestionnaireId(selectedQuestionnaireTemplateId),
            dataTableViewTemplateIds: isDataTablesVisible
                ? selectedDataTableViewTemplateIds ?? []
                : getTableViewsByQuestionnaireId(
                      selectedQuestionnaireTemplateId
                  ) ?? [],
        };
        axios
            .post('/api/DataRequestProjects', obj)
            .then((response: any) => {
                if (response.status && response.status === 200) {
                    props.onSubmit();
                    props.setIsVisible(false);
                } else {
                    createNotification(response.response.data.detail, 'error');
                }
            })
            .catch(() => {
                createNotification(
                    'Error occured while project creation',
                    'error'
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const isSubmitButtonDisabled = () => {
        const isRequiredFieldEmpty =
            !selectedMemberOption ||
            !selectedPracticeOption ||
            !selectedProjectOption;

        return (
            isRequiredFieldEmpty ||
            hasSelectedFormsError() ||
            !isAnyFormSelected()
        );
    };

    const hasSelectedFormsError = (): boolean => {
        if (
            (isDocumentDataFormVisible &&
                Number.isNaN(selectedDocumentTemplateId)) ||
            (isFinancialRequestsDataFormVisible &&
                Number.isNaN(selectedFinancialRequestsTemplateId)) ||
            (isQuestionnaireDataFormVisible &&
                Number.isNaN(selectedQuestionnaireTemplateId)) ||
            (isDataTablesVisible && !selectedDataTableTemplateIds?.length)
        ) {
            return true;
        }

        return false;
    };

    const isAnyFormSelected = (): boolean =>
        (isDocumentDataFormVisible && !!selectedDocumentTemplateId) ||
        (isFinancialRequestsDataFormVisible &&
            !!selectedFinancialRequestsTemplateId) ||
        (isQuestionnaireDataFormVisible && !!selectedQuestionnaireTemplateId) ||
        (isDataTablesVisible && !!selectedDataTableTemplateIds?.length);

    const renderOwnerFields = () => {
        return (
            <>
                <Row>
                    <Col md={4}>
                        <div className="field-label">Select Member</div>
                    </Col>
                    <Col md={8}>
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            data={memberOptions}
                            defaultValue={memberOptions[0]}
                            onChange={(value) => {
                                handleMemberChange(value);
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="practiceOwner"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <div className="field-label">Select Practice</div>
                    </Col>
                    <Col md={8}>
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            data={practiceNameOptions}
                            defaultValue={practiceNameOptions[0]}
                            onChange={(value) => {
                                handlePracticeNameChange(value);
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="name"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <div className="field-label">Project</div>
                    </Col>
                    <Col md={8}>
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            data={projectOptions}
                            defaultValue={projectOptions[0]}
                            onChange={(value) => {
                                handleProjectOptionChange(value);
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="name"
                        />
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <div className="onboard-new-client">
            <Rodal
                visible={props.isVisible}
                onClose={() => {
                    props.setIsVisible(false);
                }}
                className="checkout-modal create-event-modal"
                width={600}
                animation={'fade'}
                showMask={true}
                centered>
                <ModalHeader>Define New Project</ModalHeader>
                <ModalBody>
                    {renderOwnerFields()}
                    <Row>
                        <Col md={4}>
                            <div className="fields-block-label">
                                Configure Tables
                            </div>
                        </Col>
                    </Row>
                    <DefineNewProjectTablesForm
                        isDataTablesVisible={isDataTablesVisible}
                        setIsDataTablesVisible={setIsDataTablesVisible}
                        isDocumentDataFormVisible={isDocumentDataFormVisible}
                        setIsDocumentDataFormVisible={
                            setIsDocumentDataFormVisible
                        }
                        dataTables={dataTables}
                        selectedDataTableTemplateIds={
                            selectedDataTableTemplateIds
                        }
                        isFinancialRequestsDataFormVisible={
                            isFinancialRequestsDataFormVisible
                        }
                        setIsFinancialRequestsDataFormVisible={
                            setIsFinancialRequestsDataFormVisible
                        }
                        isQuestionnaireDataFormVisible={
                            isQuestionnaireDataFormVisible
                        }
                        setIsQuestionnaireDataFormVisible={
                            setIsQuestionnaireDataFormVisible
                        }
                        setQuestionnaireFormName={setQuestionnaireFormName}
                        selectedDataTableViewTemplateIds={
                            selectedDataTableViewTemplateIds
                        }
                        setSelectedDataTableViewTemplateIds={
                            setSelectedDataTableViewTemplateIds
                        }
                        getTableViewsByQuestionnaireId={
                            getTableViewsByQuestionnaireId
                        }
                        selectedQuestionnaireTemplateId={
                            selectedQuestionnaireTemplateId
                        }
                        getTablesByQuestionnaireId={getTablesByQuestionnaireId}
                        setSelectedDataTableTemplateIds={
                            setSelectedDataTableTemplateIds
                        }
                        setSelectedQuestionnaireTemplateId={
                            setSelectedQuestionnaireTemplateId
                        }
                        setSelectedFinancialRequestsTemplateId={
                            setSelectedFinancialRequestsTemplateId
                        }
                        setSelectedDocumentTemplateId={
                            setSelectedDocumentTemplateId
                        }
                        setQuestionnaireForms={setQuestionnaireForms}
                        setDataTables={
                            setDataTables
                        }></DefineNewProjectTablesForm>
                    <Row className="mb-0">
                        <Col className="button-container">
                            <ButtonLoader
                                buttonText={`Create New Project`}
                                loaderButtonText={''}
                                disabled={isSubmitButtonDisabled()}
                                isLoading={isLoading}
                                onClick={() => {
                                    defineNewProject();
                                }}
                                className={
                                    'btn btn-primary loader-submit'
                                }></ButtonLoader>
                        </Col>
                    </Row>
                </ModalBody>
            </Rodal>
        </div>
    );
};
